import React, { useEffect, useContext, useState } from 'react';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import Icon_Color_Unsaved from '../../Assets/Icons/Icon_Color_Unsaved.png';
import { Context_UI } from '../../Contexts/Context_UI';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useAccounts } from '../../Contexts/Context_Accounts';
import UI_List_Manager from '../ERUMAUI/UI_List_Manager';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Card from '../ERUMAUI/UI_Card';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_UpdatingStatus from '../ERUMAUI/UI_UpdatingStatus';

export default function Subwindow_Accounts_Choose_Multiple({ zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { List_Unsaved, Confirmer_Respond, Unsaved_Remove_All } = useStatus();
    const { Accounts_List, Account_Fetch_ByID_FromState, Accounts_Selector_List, Accounts_Selector_List_Set } = useAccounts();
    const Cancel = () => {
        Confirmer_Respond(false, {}, true, "Window_Accounts_Choose_Multiple");
    }

    const Discard = () => {
        Unsaved_Remove_All();
        Confirmer_Respond(true, {}, true, "Window_Accounts_Choose_Multiple");
    }

    const Confirm = (ID) => {
        Confirmer_Respond(true, Accounts_Selected, true, "Window_Accounts_Choose_Multiple");
    }

    useEffect(() => {
        const el = document.getElementById("Window_Accounts_Choose_Multiple");
        if (el) {
            el.setAttribute("Visibility", "Open");
            el.setAttribute("State", isActive ? "Active" : "Inactive");
            el.style.zIndex = zIndex;
        }
    }, [zIndex, isActive]);

    const [Accounts_Selected, Accounts_Selected_Set] = useState([]);

    useEffect(() => {
        Accounts_Selected_Set(Accounts_Selector_List);
    }, [])

    useEffect(() => {
        Accounts_Selector_List_Set(Accounts_Selected);
    }, [Accounts_Selected])

    const Select = (ID) => {
        if (!Accounts_Selected.includes(ID)) {
            Accounts_Selected_Set([...Accounts_Selected, ID]);
        } else {
            const Filtered = Accounts_Selected.filter(Item => Item !== ID);
            Accounts_Selected_Set(Filtered);
        }
        
    }


    return (
        <ui-subwindow Type='Subwindow' id='Window_Accounts_Choose_Multiple' State='Inactive' Visibility='Close' style={{ height: "95%" }}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    Choose accounts to include
                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Cancel}>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div className='General_Split' Split="2" style={{ height: "-webkit-fill-available", overflowY: "auto" }}>
                    <div style={{ height: "-webkit-fill-available", overflowY: "auto", display: "flex", flexDirection: "column", gap: "10px" }}>
                        <UI_UpdatingStatus
                            State={Accounts_Selected.length > 0 ? "Good" : "Bad"}
                            Good={{
                                Type: "Custom",
                                Content: <div style={{ height: "-webkit-fill-available", overflowY: "auto", display: "flex", flexDirection: "column", gap: "10px", paddingRight: "10px" }}>
                                    <UI_Divider Text="Selected accounts" />
                                    <p className='General_Paragraph'>
                                        Click an item to the list to remove it.
                                    </p>
                                    {Accounts_Selected.map((Item, Index) => (
                                        <UI_Card
                                            Type="Schedule_List"
                                            Figure={{
                                                Title: Account_Fetch_ByID_FromState(Item).Name,
                                                Main: Account_Fetch_ByID_FromState(Item).Email
                                            }}
                                            onClick={() => Select(Item)}
                                        />
                                    ))}
                                </div>
                            }}
                            Bad={{
                                Type: "Default",
                                Icon: "Default",
                                Title: "No accounts selected",
                                Text: "Click on an account on the right to add it to the list."
                            }}
                        />
                    </div>
                    
                    
                    <div style={{ height: "-webkit-fill-available", overflowY: "auto", paddingRight: "10px" }}>
                        <UI_Divider Text="Accounts list" />
                        <UI_List_Manager
                            id="Schedules_List"
                            Options_Display={{
                                Composition: "Linear"
                            }
                            }
                            Input={Accounts_List}
                            Keys_Searchable={["Name_Compounded", "Email"]}
                            Filters={{
                                Status: {
                                    Options: [
                                        {
                                            Label: "Approved",
                                            Icon: <UI_Icon Name="Check" />
                                        },
                                        {
                                            Label: "Pending for approval",
                                            Icon: <UI_Icon Name="Pending" />
                                        },
                                        {
                                            Label: "Rejected",
                                            Icon: <UI_Icon Name="Cross" />
                                        },
                                        {
                                            Label: "Deactivated",
                                            Icon: <UI_Icon Name="Cross" />
                                        },
                                        {
                                            Label: "Teacher",
                                            Icon: <UI_Icon Name="Teacher" />
                                        },
                                        {
                                            Label: "Staff/OSA",
                                            Icon: <UI_Icon Name="User" />
                                        },
                                        {
                                            Label: "Administrator",
                                            Icon: <UI_Icon Name="Administrator" />
                                        }
                                    ],
                                    Logic: (Item, Selected) => {
                                        const State = Item.Approval.State;
                                        const Role = Item.Role;
                                        switch (Selected) {
                                            case "Fully approved":
                                                return State === "Approved";
                                            case "Pending for approval":
                                                return State === "Pending";
                                            case "Rejected":
                                                return State === "Rejected";
                                            case "Deactivated":
                                                return State === "Deactivated";
                                            case "Teacher":
                                                return Role === "Teacher";
                                            case "Staff/OSA":
                                                return Role === "Staff";
                                            case "Administrator":
                                                return Role === "Administrator";
                                            case "All":
                                            default:
                                                return true;
                                        }
                                    }
                                }
                            }}
                            Options_Sort={[
                                {
                                    Label: "Name (A-Z)",
                                    Key: "Name_Compounded",
                                    Direction: "Ascending"
                                },
                                {
                                    Label: "Newest",
                                    Key: "Time.Start",
                                    Direction: "Ascending"
                                }
                            ]}
                            Output={(Item) => (
                                <UI_Card
                                    Type="Schedule_List"
                                    Figure={{
                                        Title: Item.Name_Compounded,
                                        Main: Item.Email,
                                        Chip: [{
                                            Text: Item.Role,
                                            Color: "Border"
                                        }],
                                    }}
                                    Subtype={Accounts_Selected.includes(Item._id) ? "Selected" : ""}
                                    onClick={() => Select(Item._id)}
                                // onClick={() => Reservation_Handle(Item._id)}
                                />
                            )}
                        />
                    </div>
                    
                </div>
                
            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Cancel}>
                    Cancel
                </button>
                
                <button className='General_Button Subwindow_Control' Type='Primary' onClick={Confirm}>
                    Save changes
                </button>
                
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
